import React, { useState } from 'react';
import PlayersListContent from '../player/PlayersList';
import ParticipantGroupMemberList from '../member/ParticipantGroupMemberList';
import OfflineBanner from '../shell/OfflineBanner';
import './PlayersList.css';

const TABS = [
  { key: 'players', label: 'Spieler' },
  { key: 'groups', label: 'Gruppen' },
];

// /users: tab "Spieler" (all players) and tab "Gruppen" (team + members of a group per year).
// A tab is mounted on first use and then only hidden, so switching back costs no new requests.
function PlayersList() {
  const [activeTab, setActiveTab] = useState('players');
  const [visited, setVisited] = useState({ players: true });

  const selectTab = (key) => {
    setActiveTab(key);
    setVisited(prev => (prev[key] ? prev : { ...prev, [key]: true }));
  };

  return (
    <React.Fragment>
      <main className={"playersPageMain"}>
        <OfflineBanner />
        <div className={"playersPageTabs"} role="tablist">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`playersPageTab${activeTab === tab.key ? ' playersPageTabActive' : ''}`}
              onClick={() => selectTab(tab.key)}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.key}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className={"playersPageTabContent"}>
          <div hidden={activeTab !== 'players'}>
            <PlayersListContent />
          </div>
          {visited.groups && (
            <div hidden={activeTab !== 'groups'}>
              <ParticipantGroupMemberList />
            </div>
          )}
        </div>
      </main>
    </React.Fragment>
  );
}

export default PlayersList;
